// Edit pages opened from a preview get its address in ?back.
// Leaving the page returns there: through the browser history when the preview is the previous entry,
// so the browser "Back" button does not lead to the edit page again.
export default {
    data() {
        return {
            cameFromBackPath: false
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.cameFromBackPath = !!from.name && from.fullPath === to.query.back
        })
    },
    methods: {
        previewBackPath() {
            const back = this.$route.query.back
            if (typeof back === 'string' && back.indexOf('/preview/') === 0) {
                return back
            }
            return null
        },
        leaveTo(listPath) {
            const back = this.previewBackPath()
            if (back && this.cameFromBackPath) {
                this.$router.back()
                return
            }
            this.$router.push(back || listPath)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/previewBackLink.js